import { ContractDuration } from "../../file.interface";
import { useAppContext } from "../../AppContext";
const contractDuration: ContractDuration[] = Object.values(ContractDuration);

export const RadioContractDuration = () => {
  //
  const { selectedContractDuration, dispatch } = useAppContext();
  const updateContractDuration = (termSelected: ContractDuration) => {
    dispatch({
      type: "UPDATE_CONTEXT",
      payload: { selectedContractDuration: termSelected },
    });
  };
  return (
    <div className="radio-buttons-container">
      {contractDuration.map((term, i) => {
        let _termFormatted = term.split(" ").join("");
        return (
          <div className="radio-item" key={term + i}>
            <input
              type="radio"
              name={_termFormatted}
              value={term}
              id={_termFormatted}
              checked={selectedContractDuration === term}
              onChange={() => updateContractDuration(term)}
            />
            <label htmlFor={_termFormatted}>{term}</label>
          </div>
        );
      })}
    </div>
  );
};
